import { colors } from "utils/constants";

const GiftCardComponent = ({ cardDesignImage, glowing = false, onClick, style }) => (
  <div className='giftCard' onClick={onClick} style={style}>

    <style jsx>{`
      .giftCard {
        min-width: 240px;
        width: 45%;
        max-width: 320px;
        height: 150px;
        background-color: gray;
        margin: 6px;
        border-radius: 5px;
        box-shadow: 0 0 7px ${glowing ? `3px ${colors.brand.neon}` : 'gray'};
        cursor: ${onClick ? 'pointer' : 'default'};
        overflow: hidden;
        background-image: url(${cardDesignImage});
        background-size: cover;
        background-position: center;
        transition: 0.2s;
      }
    `}</style>
  </div>
);

export default GiftCardComponent;